import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { eyeOffOutline, eyeOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';

@Directive({
  selector: '[togglePassword]',
  standalone: true,
})
export class TogglePasswordDirective implements AfterViewInit {
  private _shown = false;

  constructor(private el: ElementRef) {
    addIcons({eyeOutline, eyeOffOutline});
  }

  ngAfterViewInit(): void {
    const parent = this.el.nativeElement.parentNode;
    const span = document.createElement('span');
    span.innerHTML = '<ion-icon name="eye-outline"></ion-icon>';
    span.style.cursor = 'pointer';
    span.style.position = 'absolute';
    span.style.right = '10px';
    span.style.top = '7px';
    span.style.zIndex = '999';
    span.style.padding = '4px 5px 0';


    span.addEventListener('click', () => {
      // console.log('toggle', span);
      this.toggle(span);
    });

    parent.appendChild(span);
  }

  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      span.innerHTML = '<ion-icon name="eye-off-outline"></ion-icon>';

    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      span.innerHTML = '<ion-icon name="eye-outline"></ion-icon>';
      
    }
  }
}
